import { FilterBase } from "@models/base/filterBase.model";

export class RegistroContableFilter extends FilterBase{
  public idsTipoRegistroContable: number[] | null = null;
  public idsEstadoRegistroContable: number[] | null = null;
  public idsExpediente: number[] | null = null;
  public idsPlanillaCaja: number[] | null = null;
  public idsCuentaCaja: number[] | null = null;
  public fechaAltaDesde: Date | null = null;
  public fechaAltaHasta: Date | null = null;
  public fechaModificacionDesde: Date | null = null;
  public fechaModificacionHasta: Date | null = null;
  public fechaBajaDesde: Date | null = null;
  public fechaBajaHasta: Date | null = null;
  public fechaDesde: Date | null = null;
  public fechaHasta: Date | null = null;
  public esEditable: boolean | null = null;
  public aprobadoPor: number | null = null;
  public idCuentaContable: number | null = null;
  public idAsientoContable: number | null = null;
  public idRegistroRelacionado: number | null = null;
  public idComprobante: number | null = null;
  public idExpediente: number | null = null;
}
